// extracted by mini-css-extract-plugin
export default {"activeTab":"PlaylistValidatorTabs_activeTab__xQhDt","tabs":"PlaylistValidatorTabs_tabs__JTr86"};